module.exports = __webpack_public_path__ + "static/media/story-modal-bg-mob.f9b154d1.png";